import React, { useState } from "react";
import "./index.scss";
import Icon from "../../assets/images/menu-icon.svg";
import NavigationMobile from "./components/ContenNavigationMobile";
// import { useTheme } from "../../hook/useThemes";

export default function MenuNavigate() {
  const [open, setOpen] = useState<boolean>(false);
  // const { lang } = useTheme();
  // const handleClickNavigate = () => {
  //   console.log("click");
  // };

  return (
    <div className="wrapper-menu-navigate" onClick={() => setOpen(!open)}>
      <img
        src={Icon}
        alt="wrapper-menu-navigate"
        onClick={() => setOpen(!open)}
      />
      {/* {lang?.menu || "Menu"} */}

      <NavigationMobile open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
